document.addEventListener('DOMContentLoaded', function () {
  const container = document.querySelector('.option-selector__btns');
  if (!container) return;

  const normalize = (str) =>
    str
      .toLowerCase()
      .replace(/\s*[-–|]\s*(hpl|compact|solid core.*|ace surfaces.*)$/i, '')
      .trim();

  const currentTitle = normalize(container.dataset.productTitle);

  container.querySelectorAll('a.opt-label--btn').forEach((link) => {
    const linkTitle = link.textContent.trim();

    // If button label equals current product type, mark active
    if (normalize(linkTitle) === currentTitle) {
      link.classList.add('active');
      link.setAttribute('aria-disabled', 'true');
      link.addEventListener('click', (e) => e.preventDefault());
      return;
    }

    // Replace history when switching versions
    link.addEventListener('click', function (e) {
      e.preventDefault();
      window.location.replace(link.href);
    });
  });
});
